module.exports = __webpack_public_path__ + "img/phone-call-icon.8c027cb5.svg";